import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22root-layout.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../public/fonts/Calibri/Calibri%20Regular.ttf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/Calibri/Calibri%20Italic.ttf%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22../../../public/fonts/Calibri/Calibri%20Light.ttf%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/Calibri/Calibri%20Light%20Italic.ttf%22,%22weight%22:%22300%22,%22style%22:%22italic%22},{%22path%22:%22../../../public/fonts/Calibri/Calibri%20Bold.ttf%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/Calibri/Calibri%20Bold%20Italic.ttf%22,%22weight%22:%22700%22,%22style%22:%22italic%22}]}],%22variableName%22:%22calibri%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'calibri', 'calibri Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
